import React from "react";
import { connect } from "react-redux";
import { Warning } from "../../components/button";
import logoImg from "../../assets/images/64.png";
import { Div, LogoContainer, Logo, Title, ItemData } from "./style";
import { Slide } from "../../components/dialog";

const Disabled = ({ refrence, theme, settings }) => {
  return (
    <>
      <Slide ref={refrence} onBackClose={false}>
        <Div className="p-4 py-3 text-right mb-2">
          <LogoContainer className="d-inline-block w-22" theme={theme}>
            <Logo className="img-fluid" src={logoImg} />
          </LogoContainer>
          <Div className="d-inline-block vertical-align-middle mr-3 w-70">
            {!settings?.restaurant_status ? (
              <>
                <Title className="f-15" theme={theme}>
                  رستوران بسته میباشد
                </Title>
                <Div className="mt-1">
                  <ItemData className="f-12" theme={theme}>
                    {settings?.restaurant_message}
                  </ItemData>
                </Div>
              </>
            ) : (
              <>
                <Title className="f-15" theme={theme}>
                  فاقد سرویس
                </Title>
                <Div className="mt-1">
                  <ItemData className="f-12" theme={theme}>
                    آدرس شما در محدوده مجاز رستوران نمی باشد.
                  </ItemData>
                </Div>
              </>
            )}
          </Div>
          <Warning
            title="فهمیدم"
            className="d-block mt-3"
            onClick={() => {
              refrence.current.changeStatus();
            }}
          />
        </Div>
      </Slide>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
    settings: state.settings?.settings,
  };
};

export default connect(mapStateToProps, false)(Disabled);
